import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { CalendarDays, Save } from "lucide-react";
import { DAY_NAMES } from "@/lib/schedule";

export const AdminWeeklyHours = ({ weekly, saving, onSave }) => {
  const [rows, setRows] = useState(weekly || []);
  useEffect(() => setRows(weekly || []), [weekly]);

  const update = (i, patch) => setRows(rows.map((r, idx) => (idx === i ? { ...r, ...patch } : r)));

  const save = () => {
    const parsed = rows.map((r) => ({ closed: r.closed, open: Number(r.open), close: Number(r.close) }));
    const bad = parsed.findIndex((r) => !r.closed && (r.open < 0 || r.open > 23 || r.close < 1 || r.close > 24 || r.close <= r.open));
    if (bad !== -1) {
      toast.error(`${DAY_NAMES.ru[bad]}: проверьте часы (0–24, закрытие позже открытия)`);
      return;
    }
    onSave({ weekly_hours: parsed });
  };

  return (
    <Card className="p-5 lg:col-span-2" data-testid="admin-weekly-hours">
      <h3 className="font-bold mb-1 flex items-center gap-2">
        <CalendarDays className="w-5 h-5 text-emerald-600" />
        Обычный график работы
      </h3>
      <p className="text-sm text-gray-600 mb-4">Часы по дням недели (0–24, 24 = полночь). Отображаются на сайте и используются для приёма заказов.</p>
      <ul className="divide-y">
        {rows.map((r, i) => (
          <li key={i} className="flex flex-wrap items-center gap-3 py-2.5" data-testid={`weekly-row-${i}`}>
            <span className="w-32 font-medium">{DAY_NAMES.ru[i]}</span>
            <label className="flex items-center gap-2 text-sm text-gray-700">
              <Switch checked={!r.closed} onCheckedChange={(v) => update(i, { closed: !v })} data-testid={`weekly-open-switch-${i}`} />
              {r.closed ? "Выходной" : "Работаем"}
            </label>
            {!r.closed && (
              <div className="flex items-center gap-2">
                <Input type="number" min={0} max={23} value={r.open} onChange={(e) => update(i, { open: e.target.value })} className="w-20" data-testid={`weekly-open-input-${i}`} />
                <span className="text-gray-500">—</span>
                <Input type="number" min={1} max={24} value={r.close} onChange={(e) => update(i, { close: e.target.value })} className="w-20" data-testid={`weekly-close-input-${i}`} />
              </div>
            )}
          </li>
        ))}
      </ul>
      <Button onClick={save} disabled={saving} className="mt-4" data-testid="weekly-hours-save-btn">
        <Save className="w-4 h-4 mr-1" /> Сохранить график
      </Button>
    </Card>
  );
};
